import { useMemo } from 'react';
import intersection from 'lodash/intersection';
import PropTypes from 'prop-types';

import { useGetPermissionsQuery } from 'services/permissionsService';

export default function usePermission({ subject, permissions }) {
  const { data: permissionsData, isFetching, error } = useGetPermissionsQuery();

  const isAllowed = useMemo(() => {
    const actions = permissionsData?.data
      ?.filter((pd) => pd?.subject === subject)
      ?.map((fpd) => fpd.action);

    return intersection(permissions, actions)?.length > 0;
  }, [permissions, permissionsData?.data, subject]);

  return { isAllowed, isFetching, error };
}

usePermission.propTypes = {
  subject: PropTypes.string,
  permissions: PropTypes.arrayOf(PropTypes.string),
};
